
import React, { useRef, useContext } from 'react';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { useTranslation } from 'react-i18next';
import DataContext from './context/DataContext';
import ReactCountryFlag from "react-country-flag";

export default function LanguageButton() {
    const { t } = useTranslation();
    const { i18n } = useTranslation();
    const { language, setLanguage } = useContext(DataContext);
    const toast = useRef(null);

    // Language configuration with flags and codes
    const languages = [
        {
            code: 'GB',
            i18nCode: 'en',
            label: 'English',
            flag: 'GB',
            displayName: 'ENG'
        },
        {
            code: 'TZ',
            i18nCode: 'sw',
            label: 'Swahili',
            flag: 'TZ',
            displayName: 'SW'
        }
    ];

    // Get current language info
    const getCurrentLanguage = () => {
        return languages.find(lang => lang.code === language) || languages[0];
    };

    const currentLanguage = getCurrentLanguage();

    // Handle language change
    const handleLanguageChange = (selectedLanguage) => {
        setLanguage(selectedLanguage.code);
        i18n.changeLanguage(selectedLanguage.i18nCode);
        // toast.current.show({ 
        //     severity: 'success', 
        //     summary: 'Language Changed', 
        //     detail: `Language set to ${selectedLanguage.label}`,
        //     life: 2000
        // });
    };

    // Create dropdown items with flags
    const items = languages.map(lang => ({
        label: (
            <div className="flex align-items-center gap-2">
                <ReactCountryFlag
                    countryCode={lang.flag}
                    style={{
                        fontSize: "0.9em",
                        borderRadius: "2px"
                    }}
                />
                <span>{lang.displayName}</span>
            </div>
        ),
        command: () => handleLanguageChange(lang)
    }));

    return (
        <div className="flex justify-content-center">
            <Toast ref={toast} position="top-right" />
            <SplitButton
                label={
                    <div className="flex align-items-center gap-1">
                        <ReactCountryFlag
                            countryCode={currentLanguage.flag}
                            style={{
                                fontSize: "0.9em",
                                borderRadius: "2px"
                            }}
                        />
                        <span className="font-medium text-sm">{currentLanguage.displayName}</span>
                    </div>
                }
                severity="secondary"
                outlined
                model={items}
                className="language-switcher"
                buttonClassName="p-button-outlined p-button-secondary"
                menuClassName="language-dropdown"
            />
        </div>
    );
}
        